import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  max-width: 424px;
  margin: 0 auto;
`;
